/* tslint:disable */
/* eslint-disable */
/**
 * CommercialSelfservice
 *  # Introduction Backend for frontend commercial self service
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: p.integration@almbrand.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * How often is the insurance premium charged
 * @export
 * @enum {string}
 */

export const Charged = {
    EveryMonth: 'EVERY_MONTH',
    EveryTwoMonths: 'EVERY_TWO_MONTHS',
    EveryThreeMonths: 'EVERY_THREE_MONTHS',
    EveryFourMonths: 'EVERY_FOUR_MONTHS',
    EverySixMonths: 'EVERY_SIX_MONTHS',
    EveryYear: 'EVERY_YEAR',
    Once: 'ONCE'
} as const;

export type Charged = typeof Charged[keyof typeof Charged];


/**
 * 
 * @export
 * @interface CommonProblem
 */
export interface CommonProblem {
    /**
     * An absolute URI that identifies the problem type.  When dereferenced, it SHOULD provide human-readable documentation for the problem type (e.g., using HTML). 
     * @type {string}
     * @memberof CommonProblem
     */
    'type'?: string;
    /**
     * A short, summary of the problem type. Written in english and readable for engineers (usually not suited for non technical stakeholders and not localized); example: Service Unavailable 
     * @type {string}
     * @memberof CommonProblem
     */
    'title'?: string;
    /**
     * The HTTP status code generated by the origin server for this occurrence of the problem. 
     * @type {number}
     * @memberof CommonProblem
     */
    'status'?: number;
    /**
     * A human readable explanation specific to this occurrence of the problem. 
     * @type {string}
     * @memberof CommonProblem
     */
    'detail'?: string;
    /**
     * An absolute URI that identifies the specific occurrence of the problem. It may or may not yield further information if dereferenced. 
     * @type {string}
     * @memberof CommonProblem
     */
    'instance'?: string;
}
/**
 * 
 * @export
 * @interface ConsentUpdateRequest
 */
export interface ConsentUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ConsentUpdateRequest
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsentUpdateRequest
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface Coverage
 */
export interface Coverage {
    /**
     * 
     * @type {string}
     * @memberof Coverage
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof Coverage
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Coverage
     */
    'subtitle'?: string;
    /**
     * Indicates if the coverage is included or not
     * @type {boolean}
     * @memberof Coverage
     */
    'covered'?: boolean;
    /**
     * 
     * @type {Array<InsurableObjectProperty>}
     * @memberof Coverage
     */
    'properties'?: Array<InsurableObjectProperty>;
    /**
     * List of sub coverages
     * @type {Array<Subcoverage>}
     * @memberof Coverage
     */
    'sub_coverages'?: Array<Subcoverage>;
}
/**
 * 
 * @export
 * @interface CustomerAccount
 */
export interface CustomerAccount {
    /**
     * 
     * @type {string}
     * @memberof CustomerAccount
     */
    'account_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccount
     */
    'source_system'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccount
     */
    'party_type'?: string;
}
/**
 * 
 * @export
 * @interface CustomerAddress
 */
export interface CustomerAddress {
    /**
     * 
     * @type {string}
     * @memberof CustomerAddress
     */
    'in_one_line'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddress
     */
    'street_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddress
     */
    'building_no_and_letter'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerAddress
     */
    'postal_code'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddress
     */
    'city_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddress
     */
    'floor'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddress
     */
    'floor_side_code'?: string;
}
/**
 * 
 * @export
 * @interface CustomerConsent
 */
export interface CustomerConsent {
    /**
     * 
     * @type {string}
     * @memberof CustomerConsent
     */
    'consent_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerConsent
     */
    'consent_developer_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerConsent
     */
    'consent_text'?: string;
    /**
     * 
     * @type {Array<CustomerConsentChannel>}
     * @memberof CustomerConsent
     */
    'consent_channels'?: Array<CustomerConsentChannel>;
}
/**
 * 
 * @export
 * @interface CustomerConsentChannel
 */
export interface CustomerConsentChannel {
    /**
     * 
     * @type {string}
     * @memberof CustomerConsentChannel
     */
    'channel_business_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerConsentChannel
     */
    'channel_developer_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerConsentChannel
     */
    'channel_is_given_consent_current'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerConsentChannel
     */
    'channel_is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface CustomerContact
 */
export interface CustomerContact {
    /**
     * 
     * @type {CustomerAddress}
     * @memberof CustomerContact
     */
    'address'?: CustomerAddress;
    /**
     * 
     * @type {Array<CustomerContactDetail>}
     * @memberof CustomerContact
     */
    'contact_details'?: Array<CustomerContactDetail>;
}
/**
 * 
 * @export
 * @interface CustomerContactDetail
 */
export interface CustomerContactDetail {
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDetail
     */
    'detail'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerContactDetail
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface CustomerDetailsResponse
 */
export interface CustomerDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailsResponse
     */
    'customer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailsResponse
     */
    'business_brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailsResponse
     */
    'name'?: string;
    /**
     * 
     * @type {CustomerPerson}
     * @memberof CustomerDetailsResponse
     */
    'person'?: CustomerPerson;
    /**
     * 
     * @type {CustomerHousehold}
     * @memberof CustomerDetailsResponse
     */
    'household'?: CustomerHousehold;
    /**
     * 
     * @type {CustomerOrganisation}
     * @memberof CustomerDetailsResponse
     */
    'organisation'?: CustomerOrganisation;
    /**
     * 
     * @type {CustomerContact}
     * @memberof CustomerDetailsResponse
     */
    'contact'?: CustomerContact;
    /**
     * 
     * @type {Array<CustomerAccount>}
     * @memberof CustomerDetailsResponse
     */
    'accounts'?: Array<CustomerAccount>;
    /**
     * 
     * @type {Array<CustomerConsent>}
     * @memberof CustomerDetailsResponse
     */
    'consents'?: Array<CustomerConsent>;
}
/**
 * 
 * @export
 * @interface CustomerDocument
 */
export interface CustomerDocument {
    /**
     * 
     * @type {string}
     * @memberof CustomerDocument
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDocument
     */
    'policy_no'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDocument
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDocument
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDocument
     */
    'topic'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDocument
     */
    'doc_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDocument
     */
    'content_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDocument
     */
    'date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerDocument
     */
    'read'?: boolean;
}
/**
 * 
 * @export
 * @interface CustomerDocumentList
 */
export interface CustomerDocumentList {
    /**
     * 
     * @type {Array<CustomerDocument>}
     * @memberof CustomerDocumentList
     */
    'documents'?: Array<CustomerDocument>;
    /**
     * 
     * @type {number}
     * @memberof CustomerDocumentList
     */
    'number_of_documents'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerDocumentList
     */
    'number_of_read_documents'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerDocumentList
     */
    'number_of_unread_documents'?: number;
}
/**
 * 
 * @export
 * @interface CustomerHousehold
 */
export interface CustomerHousehold {
    /**
     * 
     * @type {Array<CustomerPerson>}
     * @memberof CustomerHousehold
     */
    'persons'?: Array<CustomerPerson>;
}
/**
 * 
 * @export
 * @interface CustomerOrganisation
 */
export interface CustomerOrganisation {
    /**
     * 
     * @type {string}
     * @memberof CustomerOrganisation
     */
    'organisation_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrganisation
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrganisation
     */
    'cvr_nr'?: string;
}
/**
 * 
 * @export
 * @interface CustomerPerson
 */
export interface CustomerPerson {
    /**
     * 
     * @type {string}
     * @memberof CustomerPerson
     */
    'person_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPerson
     */
    'firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPerson
     */
    'lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPerson
     */
    'fullname'?: string;
}
/**
 * A date with a label
 * @export
 * @interface DateDescription
 */
export interface DateDescription {
    /**
     * 
     * @type {string}
     * @memberof DateDescription
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateDescription
     */
    'date'?: string;
}
/**
 * Deductible is the amount of money the insured will pay on an insurance claim before the coverage kicks in and pays the rest.
 * @export
 * @interface Deductible
 */
export interface Deductible extends InsurableObjectProperty {
    /**
     * 
     * @type {number}
     * @memberof Deductible
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof Deductible
     */
    'unit'?: string;
}
/**
 * The group in which the policy is categorized.
 * @export
 * @interface Group
 */
export interface Group {
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'type'?: string;
}
/**
 * Holding the information for household persons
 * @export
 * @interface HouseholdRelationship
 */
export interface HouseholdRelationship {
    /**
     * 
     * @type {string}
     * @memberof HouseholdRelationship
     */
    'for_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof HouseholdRelationship
     */
    'last_name'?: string;
}
/**
 * The Insurable Object is an item which may be included or excluded from an insurance coverage or policy, either as the object for which possible damages to the object or loss of the object is insured, or as the object for which damages caused by the object are insured
 * @export
 * @interface InsurableObject
 */
export interface InsurableObject {
    /**
     * 
     * @type {string}
     * @memberof InsurableObject
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof InsurableObject
     */
    'subtitle'?: string;
    /**
     * 
     * @type {Array<InsurableObjectProperty>}
     * @memberof InsurableObject
     */
    'properties'?: Array<InsurableObjectProperty>;
}
/**
 * 
 * @export
 * @interface InsurableObjectProperty
 */
export interface InsurableObjectProperty {
    /**
     * 
     * @type {string}
     * @memberof InsurableObjectProperty
     */
    'propertyType': string;
    /**
     * 
     * @type {string}
     * @memberof InsurableObjectProperty
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof InsurableObjectProperty
     */
    'subtitle'?: string;
}
/**
 * Limit defines the highest amount that could be paid (or can be another limit expression such as number of days of compensation), associated with the policy coverages.
 * @export
 * @interface Limit
 */
export interface Limit {
    /**
     * 
     * @type {string}
     * @memberof Limit
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Limit
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Limit
     */
    'subtitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof Limit
     */
    'prefix'?: string;
    /**
     * 
     * @type {number}
     * @memberof Limit
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof Limit
     */
    'unit'?: string;
}
/**
 * List of limits
 * @export
 * @interface LimitList
 */
export interface LimitList extends InsurableObjectProperty {
    /**
     * 
     * @type {Array<Limit>}
     * @memberof LimitList
     */
    'limits'?: Array<Limit>;
}
/**
 * 
 * @export
 * @interface Party
 */
export interface Party {
    /**
     * 
     * @type {string}
     * @memberof Party
     */
    'account_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Party
     */
    'source_system'?: string;
    /**
     * 
     * @type {string}
     * @memberof Party
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Party
     */
    'last_name'?: string;
    /**
     * Company name, falls back to last_name if no company name is available
     * @type {string}
     * @memberof Party
     */
    'company_name'?: string;
}
/**
 * 
 * @export
 * @interface PoliciesSummary
 */
export interface PoliciesSummary {
    /**
     * 
     * @type {Array<PolicySummary>}
     * @memberof PoliciesSummary
     */
    'policies'?: Array<PolicySummary>;
    /**
     * 
     * @type {Total}
     * @memberof PoliciesSummary
     */
    'total'?: Total;
}
/**
 * 
 * @export
 * @interface PolicyDetails
 */
export interface PolicyDetails {
    /**
     * 
     * @type {string}
     * @memberof PolicyDetails
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetails
     */
    'policy_number'?: string;
    /**
     * The type of policy.
     * @type {string}
     * @memberof PolicyDetails
     */
    'type'?: string;
    /**
     * 
     * @type {Status}
     * @memberof PolicyDetails
     */
    'status'?: Status;
    /**
     * 
     * @type {Group}
     * @memberof PolicyDetails
     */
    'group'?: Group;
    /**
     * 
     * @type {DateDescription}
     * @memberof PolicyDetails
     */
    'start'?: DateDescription;
    /**
     * 
     * @type {DateDescription}
     * @memberof PolicyDetails
     */
    'end'?: DateDescription;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetails
     */
    'customer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetails
     */
    'currency'?: string;
    /**
     * 
     * @type {Array<InsurableObject>}
     * @memberof PolicyDetails
     */
    'objects'?: Array<InsurableObject>;
    /**
     * title for the policy
     * @type {string}
     * @memberof PolicyDetails
     */
    'title'?: string;
    /**
     * subtitle for the policy.
     * @type {string}
     * @memberof PolicyDetails
     */
    'subtitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDetails
     */
    'condition_code'?: string;
    /**
     * 
     * @type {Price}
     * @memberof PolicyDetails
     */
    'price'?: Price;
    /**
     * A list of coverages related to the policy
     * @type {Array<Coverage>}
     * @memberof PolicyDetails
     */
    'coverages'?: Array<Coverage>;
    /**
     * A list of parties (people or organizations) related to the policy
     * @type {Array<PolicyParty>}
     * @memberof PolicyDetails
     */
    'parties'?: Array<PolicyParty>;
}
/**
 * 
 * @export
 * @interface PolicyParty
 */
export interface PolicyParty {
    /**
     * 
     * @type {string}
     * @memberof PolicyParty
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyParty
     */
    'address'?: string;
}
/**
 * 
 * @export
 * @interface PolicySummary
 */
export interface PolicySummary {
    /**
     * Identification of a policy eg. the policy number stated on the policy document signed by the customer.
     * @type {string}
     * @memberof PolicySummary
     */
    'policy_number'?: string;
    /**
     * The technical platform hosting the policy
     * @type {string}
     * @memberof PolicySummary
     */
    'source_system'?: string;
    /**
     * The type of policy.
     * @type {string}
     * @memberof PolicySummary
     */
    'type'?: string;
    /**
     * 
     * @type {Status}
     * @memberof PolicySummary
     */
    'status'?: Status;
    /**
     * 
     * @type {Group}
     * @memberof PolicySummary
     */
    'group'?: Group;
    /**
     * title for the policy
     * @type {string}
     * @memberof PolicySummary
     */
    'title'?: string;
    /**
     * subtitle for the policy.
     * @type {string}
     * @memberof PolicySummary
     */
    'subtitle'?: string;
    /**
     * 
     * @type {Price}
     * @memberof PolicySummary
     */
    'price'?: Price;
    /**
     * 
     * @type {DateDescription}
     * @memberof PolicySummary
     */
    'start'?: DateDescription;
    /**
     * 
     * @type {DateDescription}
     * @memberof PolicySummary
     */
    'end'?: DateDescription;
}
/**
 * 
 * @export
 * @interface Price
 */
export interface Price {
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'title'?: string;
    /**
     * 
     * @type {number}
     * @memberof Price
     */
    'amount'?: number;
    /**
     * 
     * @type {Charged}
     * @memberof Price
     */
    'charged'?: Charged;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'unit'?: string;
}


/**
 * The current status of the policy.
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'subtitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'type'?: StatusTypeEnum;
}

export const StatusTypeEnum = {
    Active: 'ACTIVE',
    Pending: 'PENDING',
    Offer: 'OFFER',
    Cancelled: 'CANCELLED'
} as const;

export type StatusTypeEnum = typeof StatusTypeEnum[keyof typeof StatusTypeEnum];

/**
 * 
 * @export
 * @interface Subcoverage
 */
export interface Subcoverage {
    /**
     * 
     * @type {string}
     * @memberof Subcoverage
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Subcoverage
     */
    'subtitle'?: string;
    /**
     * 
     * @type {Array<InsurableObjectProperty>}
     * @memberof Subcoverage
     */
    'properties'?: Array<InsurableObjectProperty>;
}
/**
 * Titles holds a title and subtitle only
 * @export
 * @interface Titles
 */
export interface Titles extends InsurableObjectProperty {
}
/**
 * Totals for the page and period
 * @export
 * @interface Total
 */
export interface Total {
    /**
     * 
     * @type {number}
     * @memberof Total
     */
    'amount'?: number;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Export the policy objects as CSV
         * @param {string} policyNo Unique id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPolicyObjects: async (policyNo: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyNo' is not null or undefined
            assertParamExists('exportPolicyObjects', 'policyNo', policyNo)
            const localVarPath = `/policies/{policy_no}/objects/export`
                .replace(`{${"policy_no"}}`, encodeURIComponent(String(policyNo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch customer details for the signed-in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch party
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParty: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/party`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/policies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch policy
         * @param {string} policyNo Unique id of a policy
         * @param {string} sourceSystem Source system containing the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicy: async (policyNo: string, sourceSystem: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyNo' is not null or undefined
            assertParamExists('getPolicy', 'policyNo', policyNo)
            // verify required parameter 'sourceSystem' is not null or undefined
            assertParamExists('getPolicy', 'sourceSystem', sourceSystem)
            const localVarPath = `/policies/{policy_no}`
                .replace(`{${"policy_no"}}`, encodeURIComponent(String(policyNo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sourceSystem !== undefined) {
                localVarQueryParameter['source_system'] = sourceSystem;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update customer consents for the signed-in user
         * @param {Array<ConsentUpdateRequest>} consentUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerConsents: async (consentUpdateRequest: Array<ConsentUpdateRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentUpdateRequest' is not null or undefined
            assertParamExists('updateCustomerConsents', 'consentUpdateRequest', consentUpdateRequest)
            const localVarPath = `/customer/consents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consentUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Export the policy objects as CSV
         * @param {string} policyNo Unique id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPolicyObjects(policyNo: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPolicyObjects(policyNo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.exportPolicyObjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch customer details for the signed-in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCustomerDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch party
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParty(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Party>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParty(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getParty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoliciesSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPolicies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch policy
         * @param {string} policyNo Unique id of a policy
         * @param {string} sourceSystem Source system containing the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicy(policyNo: string, sourceSystem: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicy(policyNo, sourceSystem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update customer consents for the signed-in user
         * @param {Array<ConsentUpdateRequest>} consentUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerConsents(consentUpdateRequest: Array<ConsentUpdateRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerConsents(consentUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateCustomerConsents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Export the policy objects as CSV
         * @param {string} policyNo Unique id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPolicyObjects(policyNo: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.exportPolicyObjects(policyNo, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch customer details for the signed-in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetails(options?: RawAxiosRequestConfig): AxiosPromise<CustomerDetailsResponse> {
            return localVarFp.getCustomerDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch party
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParty(options?: RawAxiosRequestConfig): AxiosPromise<Party> {
            return localVarFp.getParty(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicies(options?: RawAxiosRequestConfig): AxiosPromise<PoliciesSummary> {
            return localVarFp.getPolicies(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch policy
         * @param {string} policyNo Unique id of a policy
         * @param {string} sourceSystem Source system containing the policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicy(policyNo: string, sourceSystem: string, options?: RawAxiosRequestConfig): AxiosPromise<PolicyDetails> {
            return localVarFp.getPolicy(policyNo, sourceSystem, options).then((request) => request(axios, basePath));
        },
        /**
         * Update customer consents for the signed-in user
         * @param {Array<ConsentUpdateRequest>} consentUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerConsents(consentUpdateRequest: Array<ConsentUpdateRequest>, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDetailsResponse> {
            return localVarFp.updateCustomerConsents(consentUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Export the policy objects as CSV
     * @param {string} policyNo Unique id of a policy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public exportPolicyObjects(policyNo: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).exportPolicyObjects(policyNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch customer details for the signed-in user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCustomerDetails(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCustomerDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch party
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getParty(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getParty(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch policies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPolicies(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPolicies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch policy
     * @param {string} policyNo Unique id of a policy
     * @param {string} sourceSystem Source system containing the policy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPolicy(policyNo: string, sourceSystem: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPolicy(policyNo, sourceSystem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update customer consents for the signed-in user
     * @param {Array<ConsentUpdateRequest>} consentUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCustomerConsents(consentUpdateRequest: Array<ConsentUpdateRequest>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCustomerConsents(consentUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Content of specific customer document
         * @param {string} documentId Unique id for an document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCustomerDocument: async (documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('fetchCustomerDocument', 'documentId', documentId)
            const localVarPath = `/documents/{document_id}`
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the policy PDF
         * @param {string} policyNo Unique id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPolicyDocument: async (policyNo: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyNo' is not null or undefined
            assertParamExists('fetchPolicyDocument', 'policyNo', policyNo)
            const localVarPath = `/policies/{policy_no}/document`
                .replace(`{${"policy_no"}}`, encodeURIComponent(String(policyNo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the policy overview PDF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPolicyOverviewDocument: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark all document as read for customer
         * @summary Mark All document customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllDocumentAsReadForCustomer: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/documents/mark_read/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark document as read for customer
         * @summary Mark document customer
         * @param {string} documentId Unique id for an document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markDocumentAsReadForCustomer: async (documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('markDocumentAsReadForCustomer', 'documentId', documentId)
            const localVarPath = `/documents/mark_read/{document_id}`
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * Content of specific customer document
         * @param {string} documentId Unique id for an document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchCustomerDocument(documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchCustomerDocument(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.fetchCustomerDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the policy PDF
         * @param {string} policyNo Unique id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPolicyDocument(policyNo: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPolicyDocument(policyNo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.fetchPolicyDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the policy overview PDF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPolicyOverviewDocument(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPolicyOverviewDocument(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.fetchPolicyOverviewDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocuments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDocumentList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocuments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.getDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark all document as read for customer
         * @summary Mark All document customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAllDocumentAsReadForCustomer(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAllDocumentAsReadForCustomer(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.markAllDocumentAsReadForCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark document as read for customer
         * @summary Mark document customer
         * @param {string} documentId Unique id for an document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markDocumentAsReadForCustomer(documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markDocumentAsReadForCustomer(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.markDocumentAsReadForCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentApiFp(configuration)
    return {
        /**
         * Content of specific customer document
         * @param {string} documentId Unique id for an document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCustomerDocument(documentId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.fetchCustomerDocument(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the policy PDF
         * @param {string} policyNo Unique id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPolicyDocument(policyNo: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.fetchPolicyDocument(policyNo, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the policy overview PDF
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPolicyOverviewDocument(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.fetchPolicyOverviewDocument(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(options?: RawAxiosRequestConfig): AxiosPromise<CustomerDocumentList> {
            return localVarFp.getDocuments(options).then((request) => request(axios, basePath));
        },
        /**
         * Mark all document as read for customer
         * @summary Mark All document customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllDocumentAsReadForCustomer(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markAllDocumentAsReadForCustomer(options).then((request) => request(axios, basePath));
        },
        /**
         * Mark document as read for customer
         * @summary Mark document customer
         * @param {string} documentId Unique id for an document.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markDocumentAsReadForCustomer(documentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markDocumentAsReadForCustomer(documentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * Content of specific customer document
     * @param {string} documentId Unique id for an document.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public fetchCustomerDocument(documentId: string, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).fetchCustomerDocument(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the policy PDF
     * @param {string} policyNo Unique id of a policy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public fetchPolicyDocument(policyNo: string, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).fetchPolicyDocument(policyNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the policy overview PDF
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public fetchPolicyOverviewDocument(options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).fetchPolicyOverviewDocument(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch documents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getDocuments(options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).getDocuments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark all document as read for customer
     * @summary Mark All document customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public markAllDocumentAsReadForCustomer(options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).markAllDocumentAsReadForCustomer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark document as read for customer
     * @summary Mark document customer
     * @param {string} documentId Unique id for an document.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public markDocumentAsReadForCustomer(documentId: string, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).markDocumentAsReadForCustomer(documentId, options).then((request) => request(this.axios, this.basePath));
    }
}



